var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4L3 20",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L12 20",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H12",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.3333C16 17.7129 16.076 18.0881 16.2228 18.4339C16.3697 18.7796 16.5841 19.088 16.8516 19.3382C17.1192 19.5885 17.4337 19.775 17.7743 19.8852C18.1148 19.9954 18.4735 20.0267 18.8263 19.9772C19.1791 19.9276 19.518 19.7983 19.8202 19.5979C20.1224 19.3974 20.381 19.1305 20.5787 18.8149C20.7764 18.4992 20.9086 18.1422 20.9666 17.7677C21.0089 17.4943 20.9734 17.2312 20.8852 16.9833C20.5855 16.1413 19.7188 15.6781 18.9299 15.2581L18.8263 15.2029L21 12H16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH3);
export default __webpack_public_path__ + "static/media/h3.391f20bcb0d92474de796ce20f26f7d5.svg";
export { ForwardRef as ReactComponent };